<app-header></app-header>

<div class="main-container">

    <div class="header-section">
        <a routerLink="/dashboard"><i class="fa-solid fa-arrow-left back"></i></a>
        <span class="title">Saved Classification</span>
    </div>

    <div class="toolbar-row">
        <mat-form-field appearance="outline" class="search-field small-height">
            <mat-label>Search</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Ex. DBY7Y6" #input>
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>
            <colgroup>
                <col style="width: 25%;">
                <col style="width: 20%;">
                <col style="width: 20%;">
                <col style="width: 20%;">
                <col style="width: 20%;">
                <col style="width: 5%;">
            </colgroup>

            <ng-container matColumnDef="database">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Database </th>
                <td mat-cell *matCellDef="let row"> {{row.database_name}} </td>
            </ng-container>

            <ng-container matColumnDef="schema">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Schema </th>
                <td mat-cell *matCellDef="let row"> {{row.schema_name}}</td>
            </ng-container>

            <ng-container matColumnDef="table">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Table </th>
                <td mat-cell *matCellDef="let row"> {{row.table_name}} </td>
            </ng-container>

            <ng-container matColumnDef="createdBy">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created By </th>
                <td mat-cell *matCellDef="let row"> {{row.saved_by}} </td>
            </ng-container>

            <ng-container matColumnDef="createdOn" class="created-on-column">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created On </th>
                <td mat-cell *matCellDef="let row"> {{row.created_at | date : "MMMM dd yyyy, h:mm a" }} </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions </th>
                <td mat-cell *matCellDef="let row" class="text-center">
                    <i class="fa-solid fa-eye view-icon" (click)="viewClassification(row.filename)"></i>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell no-data-cell p-2" colspan="6">No data found</td>
            </tr>
        </table>
        <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons aria-label="Select page of files">
        </mat-paginator>
    </div>
</div>

<ng-template #descriptionDialog>
    <div class="description-dialog">
        <div class="classification-title px-3 py-2">
            <span>
                <i class="fa-solid fa-sheet-plastic"></i>
            </span>&nbsp;
            <span>Classification</span>
            <span class="float-end">
                <i class="fa-solid fa-close" aria-label="close dialog" [mat-dialog-close]="false"></i>
            </span>
        </div>

        <mat-dialog-content class="dialog-content padding-10">
            <pre>{{ classificationDetail | json }}</pre>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="dialog-actions">
            <div class="button-container">
                <button class="btn btn-primary generate-btn download-button"
                    (click)="downloadClassification(selectedFileName)">
                    <i class="fa-solid fa-download"></i> Download as CSV
                </button>
                <button class="btn btn-primary generate-btn save-button" (click)="copyJSON()">
                    <i class="fa-solid fa-copy"></i> Copy
                </button>
            </div>
        </mat-dialog-actions>
    </div>
</ng-template>